import { getRelativeTime } from '@thoughtspot/date-format-util';
import _ from 'lodash';
import { useEffect, useState } from 'react';
export const useDataHooks = (useGetGroupListQuery, isRefreshed, groupListInput, setIsLoading, setIsRefresh) => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);
    const { data: groupsList, error: groupsListError, loading: groupsListLoading, refetch: refreshGroupsList, } = useGetGroupListQuery(groupListInput);
    useEffect(() => {
        if (isRefreshed) {
            refreshGroupsList({ params: groupListInput });
            setIsRefresh(false);
        }
    }, [isRefreshed]);
    useEffect(() => {
        try {
            if (groupsList && !groupsListLoading) {
                const groupData = _.cloneDeep(groupsList);
                const parseData = groupData.objects.map((group) => {
                    const { id, displayName, name, created, numDefaultPinboards, numMemberUsers, description, } = group;
                    return {
                        id,
                        groupName: {
                            text: name || '',
                        },
                        groupDisplayName: {
                            text: displayName,
                        },
                        groupCreated: {
                            text: getRelativeTime(created),
                        },
                        memberUsers: {
                            text: numMemberUsers || 0,
                        },
                        defaultLiveBoards: {
                            text: numDefaultPinboards || 0,
                        },
                        description: {
                            text: description || '',
                        },
                        isChecked: false,
                    };
                });
                setData(parseData);
                setLoading(false);
                setIsLoading(false);
                setIsRefresh(false);
            }
        }
        catch (err) {
            setError(true);
            setLoading(false);
            setIsLoading(false);
            setIsRefresh(false);
        }
    }, [groupsList, groupListInput, groupsListLoading]);
    return {
        data,
        loading,
        error,
        isLastBatch: groupsList?.isLastBatch || false,
    };
};
//# sourceMappingURL=useDataHook.js.map